module.exports = __webpack_public_path__ + "static/img/mine_coupon@3x.7e1bd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_coupon@3x.png
// module id = KRkN
// module chunks = 1